// extracted by mini-css-extract-plugin
export default {"navbar_body":"HomeNavbar_navbar_body__pNSO5","navbar_text":"HomeNavbar_navbar_text__j57Rq"};